/**
 * notifications.provider.js
 */

import React, { useState } from "react";
import NotificationsContext from "./notifications.context";
import { UserContext } from "contexts/user/user-context";


const defaultState = {
  notifications: null,
  unreadCount: 0,
  open: false,
};


export default function NotificationsProvider({ children }) {
  const { user } = React.useContext(UserContext);
  const [state, setState] = useState(defaultState);


  const setNotifications = React.useCallback((notifications) => {
    setState(prevState => {
      return {...prevState, notifications};
    })
  }, []);

  
  const setUnreadCount = React.useCallback((unreadCount) => {
    setState(prevState => {
      return {...prevState, unreadCount};
    })
  }, []);


  const decrementUnreadCount = React.useCallback(() => {
    setState( prevState => {
      return {...prevState, unreadCount: prevState.unreadCount - 1};
    });
  }, []);


  const setOpen = React.useCallback((open) => {
    setState(prevState => {
      return {...prevState, open};
    })
  }, []);


  const setMultiple = React.useCallback((obj) => {
    setState(prevState => {
      return {...prevState, ...obj};
    })
  }, []);


  React.useEffect(() => {
    if (!user) {
      setState(defaultState);
    }
  }, [user]);
  

  const value = React.useMemo(() => ({
    ...state,
    setNotifications,
    setUnreadCount,
    decrementUnreadCount,
    setOpen,
    setMultiple
  }), [
    state,
    setNotifications,
    setUnreadCount,
    decrementUnreadCount,
    setOpen,
    setMultiple,
  ]);


  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
};